import * as React from "react";
import { Tooltip, TooltipProps } from "antd";
import Image from "next/image";

type LightTooltipProps = TooltipProps & { small?: boolean };

export const LightTooltip = ({ className, title, small, ...props }: LightTooltipProps) => (
  <Tooltip
    {...props}
    className={`${className} custom-tooltip`}
    title={
      <div style={{ color: "#00625F", fontSize: small ? "0.75rem" : undefined }}>
        {typeof title === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: title }} />
        ) : (
          String(title || "")
        )}
      </div>
    }
    placement="right"
    color="#fff"
    styles={{ root: { width: "auto", maxWidth: "25rem", }}}
  >
    <Image
      src={"/icons/tooltip.svg"}
      width={64}
      height={64}
      alt="tooltip"
      className={small ? "h-3 w-auto ml-2" : "h-4 w-auto ml-4"}
    />
  </Tooltip>
);
